export default __webpack_public_path__ + "static/media/equity-solar-bg.6411bd88.png";